import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Card, CardContent } from "../components/ui/card";
import { QueryForm } from "../components/QueryForm";
import { OwnerLayout } from "../components/OwnerLayout";
import { auth } from "../firebase";  // Add this import
import { useNavigate } from "react-router-dom";  // Add this import
import LogoutConfirmationPopup from "../components/LogoutConfirmationPopup";  // Add this import

function OwnerManagement() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  
  const handleLogout = () => {
    setShowLogoutConfirmation(true);
  };

  const confirmLogout = () => {
    auth.signOut().then(() => {
      navigate("/login");
    });
  };

  return (
    <OwnerLayout user={user} onLogout={handleLogout}>
      <div className="space-y-6 mb-16 lg:mb-0"> {/* Added mb-16 */}
        <div className="mb-8">
          <h1 className="text-2xl lg:text-4xl font-bold mb-2">Management</h1>
          <p className="text-lg lg:text-xl text-gray-600">
            Manage your account and contact support
          </p>
        </div>

        {/* Query Form */}
        <Card className="rounded-lg">
          <CardContent className="p-6 flex flex-col items-stretch justify-start">
            <h2 className="text-xl font-semibold mb-4 mt-4">Contact Admin</h2>
            <QueryForm ownerEmail={user?.email} />
          </CardContent>
        </Card>
      </div>
      {showLogoutConfirmation && (
        <LogoutConfirmationPopup
          onConfirm={confirmLogout}
          onCancel={() => setShowLogoutConfirmation(false)}
        />
      )}
    </OwnerLayout>
  );
}

export default OwnerManagement;
